import { init as initApi, update as updateApi } from "../../service/EvaluationListService";

//アクションタイプ定義
export const INIT = "EVALUATION_LIST_INIT";
export const UPDATE_SUCCESS = "EVALUATION_LIST_UPDATE_SUCCESS";
export const UPDATE_FAIL = "EVALUATION_LIST_UPDATE_FAIL";

export const init = () => dispatch => {
  initApi().then(response => {
    const abolitionFlgTexts = response.abolitionFlgText;
    const abolitionFlgValues = response.abolitionFlgValue;
    const isDisableMap = response.isDisableMap;

    const evaluationLists = response.evaluationListDtos;
    const rows = evaluationLists.map((list, index) => {
      const abolitionFlg = list.abolitionFlg === "true" ? abolitionFlgValues[1] : abolitionFlgValues[0];
      return {
        id: index,
        listId: list.listId,
        listName: list.listName,
        numberOfGrades: list.numOfGrade,
        gradeRange: list.gradeRange,
        abolition: abolitionFlg,
        registeredDate: list.createdDate,
        updatedDate: list.updatedDate
      };
    });

    dispatch({
      type: INIT,
      payload: {
        data: response,
        rows: rows,
        abolitionFlgTexts: abolitionFlgTexts,
        abolitionFlgValues: abolitionFlgValues,
        isDisableMap: isDisableMap
      }
    });
  });
};
export const update = param => dispatch => {
  updateApi(param)
    .then(() => {
      dispatch({ type: UPDATE_SUCCESS, payload: { params: param } });
      alert("評価リストを更新しました。");
    })
    .catch(error => {
      dispatch({ type: UPDATE_FAIL, payload: { error: error } });
      alert("評価リストの更新中にエラーが発生しました。");
    });
};
